import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, ChevronDown } from 'lucide-react';
import { Button } from './ui/button';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProductsOpen, setIsProductsOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => location.pathname === path;

  const productLinks = [
    { name: 'Zoho One', path: '/zoho-one' },
    { name: 'Zoho CRM', path: '/zoho-crm' },
    { name: 'Zoho Desk', path: '/zoho-desk' },
    { name: 'Zoho Books', path: '/zoho-books' },
    { name: 'Zoho Projects', path: '/zoho-projects' },
    { name: 'Zoho People', path: '/zoho-people' },
    { name: 'Zoho Vault', path: '/zoho-vault' },
    { name: 'Zoho Order Management', path: '/zoho-order-management' },
  ];

  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-md border-b border-gray-200 shadow-sm">
      <nav className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2 group">
            <div className="text-2xl font-bold text-blue-700 transition-all duration-300 group-hover:text-blue-800">
              Guijs Consultancy
            </div>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden lg:flex items-center space-x-8">
            <Link
              to="/"
              className={`text-base font-medium transition-colors duration-200 ${
                isActive('/') ? 'text-blue-700' : 'text-gray-700 hover:text-blue-700'
              }`}
            >
              Home
            </Link>
            
            <div className="relative group">
              <button className="flex items-center space-x-1 text-base font-medium text-gray-700 hover:text-blue-700 transition-colors duration-200">
                <span>Zoho Producten</span>
                <ChevronDown className="w-4 h-4" />
              </button>
              <div className="absolute left-0 mt-2 w-56 bg-white rounded-lg shadow-xl border border-gray-100 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-300 transform group-hover:translate-y-0 translate-y-2">
                <div className="py-2">
                  {productLinks.map((product) => (
                    <Link
                      key={product.path}
                      to={product.path}
                      className="block px-4 py-2 text-sm text-gray-700 hover:bg-blue-50 hover:text-blue-700 transition-colors duration-200"
                    >
                      {product.name}
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            <Link
              to="/diensten"
              className={`text-base font-medium transition-colors duration-200 ${
                isActive('/diensten') ? 'text-blue-700' : 'text-gray-700 hover:text-blue-700'
              }`}
            >
              Diensten
            </Link>

            <Link
              to="/zoho-partner"
              className={`text-base font-medium transition-colors duration-200 ${
                isActive('/zoho-partner') ? 'text-blue-700' : 'text-gray-700 hover:text-blue-700'
              }`}
            >
              Zoho Partner
            </Link>

            <Link
              to="/contact"
              className={`text-base font-medium transition-colors duration-200 ${
                isActive('/contact') ? 'text-blue-700' : 'text-gray-700 hover:text-blue-700'
              }`}
            >
              Contact
            </Link>

            <Button className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-2 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg">
              Plan een Demo
            </Button>
          </div>

          {/* Mobile menu button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="lg:hidden p-2 rounded-lg hover:bg-gray-100 transition-colors duration-200"
          >
            {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="lg:hidden py-4 border-t border-gray-200">
            <div className="flex flex-col space-y-4">
              <Link
                to="/"
                className="text-base font-medium text-gray-700 hover:text-blue-700 transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                Home
              </Link>

              <div>
                <button
                  onClick={() => setIsProductsOpen(!isProductsOpen)}
                  className="flex items-center justify-between w-full text-base font-medium text-gray-700 hover:text-blue-700 transition-colors duration-200"
                >
                  <span>Zoho Producten</span>
                  <ChevronDown className={`w-4 h-4 transition-transform duration-200 ${isProductsOpen ? 'rotate-180' : ''}`} />
                </button>
                {isProductsOpen && (
                  <div className="mt-2 ml-4 space-y-2">
                    {productLinks.map((product) => (
                      <Link
                        key={product.path}
                        to={product.path}
                        className="block text-sm text-gray-600 hover:text-blue-700 transition-colors duration-200"
                        onClick={() => setIsMenuOpen(false)}
                      >
                        {product.name}
                      </Link>
                    ))}
                  </div>
                )}
              </div>

              <Link
                to="/diensten"
                className="text-base font-medium text-gray-700 hover:text-blue-700 transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                Diensten
              </Link>

              <Link
                to="/zoho-partner"
                className="text-base font-medium text-gray-700 hover:text-blue-700 transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                Zoho Partner
              </Link>

              <Link
                to="/contact"
                className="text-base font-medium text-gray-700 hover:text-blue-700 transition-colors duration-200"
                onClick={() => setIsMenuOpen(false)}
              >
                Contact
              </Link>

              <Button className="bg-blue-700 hover:bg-blue-800 text-white w-full py-2 rounded-lg transition-all duration-300">
                Plan een Demo
              </Button>
            </div>
          </div>
        )}
      </nav>
    </header>
  );
};

export default Header;
